import {
  FETCH_SECTIONS_ACCURACY_REQUEST,
  FETCH_SECTIONS_ACCURACY_SUCCESS,
  FETCH_SECTIONS_ACCURACY_ERROR,
  FETCH_EFFECTIVENESS_SUCCESS,
  FETCH_SECTIONS_ACC_EFFEC_REQUEST,
  FETCH_SECTIONS_ACC_EFFEC_SUCCESS,
  FETCH_SECTIONS_ACC_EFFEC_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  recordsEffectiveness: [],
  error: null,
  isFetching: false,
}

const record = (state = DEFAULT_STATE, action) => {

  switch (action.type) {
    case FETCH_SECTIONS_ACC_EFFEC_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    
    case FETCH_SECTIONS_ACC_EFFEC_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        recordsSupply: action.payload,
      }
    
    case FETCH_SECTIONS_ACC_EFFEC_ERROR:
      return {
        ...state,
        isFetching: false,
        recordsSupply: [],
        error: action.payload,
      }

    case FETCH_SECTIONS_ACCURACY_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_SECTIONS_ACCURACY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        records: action.payload,
      }

    case  FETCH_EFFECTIVENESS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        recordsEffectiveness: action.payload,
      }

    case FETCH_SECTIONS_ACCURACY_ERROR:
      return {
        ...state,
        isFetching: false,
        records: [],
        recordsEffectiveness: [],
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
